import * as mammoth from "mammoth";
import { getDocument, GlobalWorkerOptions, version as pdfjsVersion } from "pdfjs-dist";

/**
 * Utility to extract text from PDF or DOCX files
 */
export async function extractTextFromFile(file: File): Promise<string> {
  if (file.name.endsWith(".docx")) {
    const arrayBuffer = await file.arrayBuffer();
    const result = await mammoth.extractRawText({ arrayBuffer });
    return result.value;
  } else if (file.name.endsWith(".pdf")) {
    const isMobile = /iPhone|iPad|Android/i.test(navigator.userAgent);
    console.log("[Alvaru Extractor] Starting PDF extraction, isMobile:", isMobile);
    
    try {
      const version = pdfjsVersion || "4.4.168";
      console.log("[Alvaru Extractor] pdf.js version:", version);
      
      // Set worker source with explicit protocol and version
      if (GlobalWorkerOptions) {
        GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.mjs`;
        console.log("[Alvaru Extractor] Worker source set to:", GlobalWorkerOptions.workerSrc);
      } else {
        console.warn("[Alvaru Extractor] GlobalWorkerOptions not found on library object");
      }

      const arrayBuffer = await file.arrayBuffer();
      console.log("[Alvaru Extractor] ArrayBuffer size:", arrayBuffer.byteLength);
      
      const loadingTask = getDocument({
        data: arrayBuffer,
        useWorkerFetch: true,
        isEvalSupported: false,
      });

      const pdf = await loadingTask.promise;
    let text = "";
    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const content = await page.getTextContent();
      
      // Filter for items that actually have text and positional data
      const items = content.items
        .filter((item: any) => item.str !== undefined) as any[];

      // Sort items by vertical position (top to bottom), then by horizontal position (left to right)
      // item.transform[5] is the Y coordinate, item.transform[4] is the X coordinate
      const sortedItems = [...items].sort((a, b) => {
        const yDiff = b.transform[5] - a.transform[5];
        if (Math.abs(yDiff) > 5) return yDiff; 
        return a.transform[4] - b.transform[4];
      });

      let pageText = "";
      let lastY = -1;
      
      for (const item of sortedItems) {
        const currentY = item.transform[5];
        if (lastY !== -1 && Math.abs(currentY - lastY) > 5) {
          pageText += "\n";
        } else if (lastY !== -1) {
          pageText += " ";
        }
        pageText += item.str;
        lastY = currentY;
      }
      
      text += pageText + "\n";
    }
      return text.trim();
    } catch (err: any) {
      console.error("[Alvaru Extractor] PDF extraction failed:", err);
      throw new Error("Could not extract text from this PDF. " + err.message);
    }
  }
  throw new Error("Unsupported file format. Please upload PDF or DOCX.");
}
